module.exports = __webpack_public_path__ + "static/media/roll-dice-60.aa6d38a4.png";